import { createFileRoute } from '@tanstack/react-router'
import { SystemPromptPage } from '@/components/system-prompt/system-prompt-page'

export const Route = createFileRoute('/coach/system-prompt')({
  component: SystemPromptPage,
})
